import styled from "styled-components";

export const StyledAddAddressModal = styled.div`
    padding: 0 20px 20px;
    font-size: 16px;
    line-height: 20px;

    .heading {
        display: block;
        font-size: 24px;
        line-height: 26px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    .map-holder {
        width: 100%;
        margin-bottom: 20px;
        .map-input {
            input {
                max-width: 90% !important;
            }
        }
    }
    .location-holder {
        padding-top: 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 15px;
        span {
            font-size: 14px;
            font-weight: 300;
            line-height: 17px;
            @media (min-width: 576px) {
                font-size: 16px;
                line-height: 19px;
            }
        }
    }
    .btn-search-wrap {
        text-align: center;
    }
`;
